// Extra mockable data layered on top of mock.js
// - caseTextures: unique wear/sticker per tape id
// - tapeDetails: rich per-tape info for detail pages
// - vaultTapes: hidden client-only shelf behind a passcode

// Case textures \u2014 each tape gets a shelf tilt, top sticker, wear pattern.
// Values used by VHSTape.jsx to produce a one-of-a-kind cover.
export const caseTextures = {
  t1: { tilt: -1.6, sticker: { label: "DEMO \u2022 DO NOT DUP", tone: "warn", offset: 6 }, wear: 0.55, corner: "tl" },
  t2: { tilt: 1.2,  sticker: { label: "PROMO COPY",         tone: "info", offset: 10 }, wear: 0.35, corner: "tr" },
  t3: { tilt: -0.4, sticker: { label: "MASTER \u2014 A ROLL",   tone: "cream", offset: 4 },  wear: 0.7,  corner: "tl" },
  t4: { tilt: 2.1,  sticker: { label: "DOC / ROUGH CUT",    tone: "info", offset: 12 }, wear: 0.9,  corner: "br" },
  t5: { tilt: -2.4, sticker: { label: "EXPERIMENT \u00b0 05",   tone: "warn", offset: 8 },  wear: 0.5,  corner: "tr" },
  t6: { tilt: 0.8,  sticker: { label: "FINAL \u2014 DELIVERED",  tone: "cream", offset: 6 },  wear: 0.8,  corner: "bl" },
  t7: { tilt: -1.0, sticker: { label: "MV CUT 03",          tone: "info", offset: 5 },  wear: 0.4,  corner: "tl" },
  t8: { tilt: 1.7,  sticker: { label: "CLIENT APPROVED",    tone: "cream", offset: 9 },  wear: 0.3,  corner: "tr" },
  v1: { tilt: -1.3, sticker: { label: "NDA \u2022 CONFIDENTIAL",  tone: "danger", offset: 8 }, wear: 0.6, corner: "tl" },
  v2: { tilt: 1.0,  sticker: { label: "PRIVATE SCREENING",   tone: "danger", offset: 10 }, wear: 0.45, corner: "tr" },
  v3: { tilt: -0.6, sticker: { label: "EMBARGO 2026",        tone: "warn",   offset: 7 },  wear: 0.7, corner: "bl" },
  v4: { tilt: 2.0,  sticker: { label: "UNRELEASED CUT",      tone: "danger", offset: 6 },  wear: 0.55, corner: "tr" },
};

export const stickerPalette = {
  cream:  { bg: "#f2ece1", text: "#0e0b09" },
  warn:   { bg: "#f5b14e", text: "#0e0b09" },
  info:   { bg: "#8ec5ff", text: "#0e0b09" },
  danger: { bg: "#e4572e", text: "#f2ece1" },
};

// Rich per-tape details rendered on the /tape/:id page.
export const tapeDetails = {
  t1: {
    client: "Personal \u00b7 Multi-brand",
    role: "Director \u00b7 Editor \u00b7 Videographer",
    format: "Mixed \u2014 broadcast, social, vertical",
    duration: "01:30",
    festivals: [],
    credits: [{ role: "Everything", name: "Alex Rivera" }],
    tools: ["Premiere Pro", "After Effects", "DaVinci Resolve", "Sony FX"],
    still: "linear-gradient(135deg, #2a2418 0%, #a8892f 50%, #1a1610 100%)",
    story:
      "A curated sizzle of recent short-form work \u2014 the campaigns, moments, and cuts that best represent how I shoot and edit for feed-first audiences.",
    related: ["t2", "t4", "t7"],
  },
  t2: {
    client: "CBS Sports \u2014 NFL on CBS",
    role: "Editor \u00b7 Motion",
    format: "Social \u2014 vertical",
    duration: "00:30",
    festivals: [],
    credits: [
      { role: "Creative Lead", name: "CBS Sports" },
      { role: "Sound Design",  name: "In-house" },
    ],
    tools: ["Premiere Pro", "After Effects", "Photoshop"],
    still: "linear-gradient(135deg, #0f1c30 0%, #4B78E4 50%, #08101c 100%)",
    story:
      "A vertical hero cut for the NFL on CBS \u2014 built to slam the first two seconds and hold attention through the whistle.",
    related: ["t4", "t8", "t1"],
  },
  t3: {
    client: "Paramount+ \u2014 Dora Movie",
    role: "Editor \u00b7 Videographer",
    format: "Theatrical / Social launch",
    duration: "00:45",
    festivals: [],
    credits: [
      { role: "Campaign Lead", name: "Paramount+ Social" },
      { role: "Color",         name: "In-house" },
    ],
    tools: ["Premiere Pro", "After Effects", "Resolve"],
    still: "linear-gradient(135deg, #2c101a 0%, #D14A5E 50%, #180a10 100%)",
    story:
      "Bright, punchy cut for the Dora movie launch \u2014 tuned to land with kids, parents, and the algorithm all at once.",
    related: ["t7", "t4", "t8"],
  },
  t4: {
    client: "Nickelodeon \u2014 Kids' Choice Awards",
    role: "Editor \u00b7 Videographer",
    format: "On-air + social campaign",
    duration: "00:30",
    festivals: [],
    credits: [
      { role: "Campaign Lead", name: "Nickelodeon On-Air" },
      { role: "Talent",        name: "KCA Nominees" },
    ],
    tools: ["Premiere Pro", "After Effects", "Photoshop"],
    still: "linear-gradient(135deg, #3a1f14 0%, #E4572E 50%, #1a0f0a 100%)",
    story:
      "Countdown promo cut around the loudest night in kids' TV \u2014 slime, chaos, superstar cameos, and 30 seconds to sell it all.",
    related: ["t7", "t8", "t3"],
  },
  t5: {
    client: "Paramount+ \u2014 Landman",
    role: "Editor",
    format: "Series launch \u2014 social",
    duration: "00:30",
    festivals: [],
    credits: [
      { role: "Campaign Lead", name: "Paramount+ Marketing" },
      { role: "Talent",        name: "Landman Cast" },
    ],
    tools: ["Premiere Pro", "After Effects", "Resolve"],
    still: "linear-gradient(135deg, #2a1a10 0%, #C97B4B 50%, #160e08 100%)",
    story:
      "Prestige-series launch cut. Texas oil, high stakes, and a tight 30 seconds of tension built for the vertical feed.",
    related: ["t6", "t2", "t1"],
  },
  t6: {
    client: "Showtime \u2014 Dexter",
    role: "Editor",
    format: "Franchise return \u2014 social",
    duration: "00:30",
    festivals: [],
    credits: [
      { role: "Campaign Lead", name: "Showtime Marketing" },
      { role: "Talent",        name: "Dexter Cast" },
    ],
    tools: ["Premiere Pro", "After Effects", "Resolve"],
    still: "linear-gradient(135deg, #1c1030 0%, #7B4BFF 50%, #0f0a1a 100%)",
    story:
      "Return-of-the-franchise promo for Dexter. Iconic silhouettes, blood-red palette, and not a wasted frame.",
    related: ["t5", "t2", "t1"],
  },
  t7: {
    client: "Nickelodeon \u2014 SpongeBob 25th",
    role: "Editor \u00b7 Videographer",
    format: "Anniversary campaign",
    duration: "00:45",
    festivals: [],
    credits: [
      { role: "Campaign Lead", name: "Nickelodeon" },
      { role: "Motion",        name: "In-house" },
    ],
    tools: ["Premiere Pro", "After Effects", "Photoshop"],
    still: "linear-gradient(135deg, #2a2010 0%, #E8A93B 50%, #1a1408 100%)",
    story:
      "A quarter-century of Bikini Bottom compressed into a punchy anniversary cut, tuned for shorts, reels, and stories.",
    related: ["t8", "t4", "t3"],
  },
  t8: {
    client: "Nickelodeon \u2014 SlimeTime Live",
    role: "Editor \u00b7 Videographer",
    format: "Live event \u2014 hype cut",
    duration: "01:00",
    festivals: [],
    credits: [
      { role: "Campaign Lead", name: "Nickelodeon Live" },
      { role: "On-Site",       name: "Videographer / AD" },
    ],
    tools: ["Premiere Pro", "After Effects", "Sony FX"],
    still: "linear-gradient(135deg, #0f2a2a 0%, #2E8B7E 50%, #08161a 100%)",
    story:
      "Cross-platform hype cut for SlimeTime Live \u2014 fast, sticky, unmistakably Nickelodeon. Shot on the ground, cut for the feed.",
    related: ["t4", "t7", "t3"],
  },
  // Vault tapes
  v1: {
    client: "\u2014",
    role: "Director",
    format: "35mm",
    duration: "22:00",
    festivals: ["Under embargo"],
    credits: [{ role: "Details", name: "Available on request" }],
    tools: ["\u2014"],
    still: "linear-gradient(135deg, #1a0a08 0%, #3a1a10 50%, #0a0605 100%)",
    story: "Feature-length short in post. Full cut available to invited clients \u2014 please reach out for a private link.",
    related: [],
  },
  v2: {
    client: "\u2014",
    role: "Director",
    format: "Digital",
    duration: "15:44",
    festivals: [],
    credits: [{ role: "Details", name: "Available on request" }],
    tools: ["\u2014"],
    still: "linear-gradient(135deg, #0a1a1a 0%, #1a4a4a 50%, #060a0a 100%)",
    story: "A brand campaign under NDA. Reach out for the private cut and credits.",
    related: [],
  },
  v3: {
    client: "\u2014",
    role: "Director \u00b7 Editor",
    format: "8mm + Digital",
    duration: "09:12",
    festivals: [],
    credits: [{ role: "Details", name: "Available on request" }],
    tools: ["\u2014"],
    still: "linear-gradient(135deg, #1a1a08 0%, #4a4a1a 50%, #0a0a05 100%)",
    story: "Experimental piece releasing in 2026. Password room preview only.",
    related: [],
  },
  v4: {
    client: "\u2014",
    role: "Director",
    format: "Digital",
    duration: "11:28",
    festivals: [],
    credits: [{ role: "Details", name: "Available on request" }],
    tools: ["\u2014"],
    still: "linear-gradient(135deg, #1a081a 0%, #4a1a4a 50%, #0a050a 100%)",
    story: "Unreleased music video cut. Full version behind the passcode.",
    related: [],
  },
};

// The private / NDA shelf tapes.
export const vaultTapes = [
  {
    id: "v1",
    title: "Ashes & Ivory",
    subtitle: "Short Film \u00b7 In Post",
    category: "Short Film",
    year: "2026",
    runtime: "22:00",
    description: "A feature-length short currently in color. Available to invited clients.",
    youtubeId: "dQw4w9WgXcQ",
    spine: "#8a1a1a",
    body: "#0a0605",
    accent: "#f2ece1",
    stripe: "#2a0f0a",
  },
  {
    id: "v2",
    title: "House of Silk",
    subtitle: "Confidential Campaign",
    category: "Commercial",
    year: "2025",
    runtime: "15:44",
    description: "Brand campaign under NDA. Reach out for the private cut.",
    youtubeId: "dQw4w9WgXcQ",
    spine: "#1a5a5a",
    body: "#060a0a",
    accent: "#9de0c6",
    stripe: "#0a2020",
  },
  {
    id: "v3",
    title: "Long Exposure",
    subtitle: "Experimental \u00b7 2026",
    category: "Experimental",
    year: "2026",
    runtime: "09:12",
    description: "Releasing 2026. Password-room preview only.",
    youtubeId: "dQw4w9WgXcQ",
    spine: "#8a8a1a",
    body: "#0a0a05",
    accent: "#f5b14e",
    stripe: "#2a2a0a",
  },
  {
    id: "v4",
    title: "Velvet Radio",
    subtitle: "Unreleased MV Cut",
    category: "Music Video",
    year: "2025",
    runtime: "11:28",
    description: "Alternate cut of an unreleased music video.",
    youtubeId: "dQw4w9WgXcQ",
    spine: "#6a1a6a",
    body: "#0a050a",
    accent: "#e1b7ff",
    stripe: "#2a0a2a",
  },
];

// Passcode to unlock the vault. Case-insensitive comparison in the UI.
// Hint shown in the UI is: "The year Alex was born \u2014 also the year VHS peaked."
export const vaultPasscode = "1985";
export const vaultHint = "Hint \u2014 the year VHS ruled the world.";
